"use strict";

exports.__esModule = true;
var HTML5NamedCharRefs = {};
exports.default = HTML5NamedCharRefs;


//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/lib/simple-html-tokenizer/html5-named-char-refs.js
// module id = 732
// module chunks = 0